import { Reducer } from 'redux';
import { getType } from '@anm/helpers/saga/typesafe-actions';

import { checkUploadAsync } from '../actions';
import { HostedVideoActions } from '../types';

import { initialHostedVideoState } from './index';

const checkUploadReducer: Reducer<
  typeof initialHostedVideoState,
  HostedVideoActions
> = (state = initialHostedVideoState, action) => {
  switch (action.type) {
    case getType(checkUploadAsync.request): {
      return {
        ...state,
        upload: {
          ...state.upload,
          error: null,
          isError: false,
          isPending: true
        }
      };
    }
    case getType(checkUploadAsync.success): {
      const response = action.payload;

      return {
        ...state,
        upload: {
          ...state.upload,
          id: response.upload.id,
          error: null,
          isError: false,
          isPending: false
        }
      };
    }
    case getType(checkUploadAsync.failure): {
      const error = action.payload;
      return {
        ...state,
        upload: {
          ...state.upload,
          error,
          isError: true,
          isPending: false
        }
      };
    }
    default:
      return state;
  }
};

export default checkUploadReducer;
